/**
 * Carousel — SwiperJS initialisation
 * ====================================
 * Reads `data-swiper-config` from each `.block-carousel .swiper` element
 * and instantiates a Swiper instance with the stored configuration.
 *
 * Swiper is imported as an ESM module and bundled into main.js by esbuild.
 * No jQuery. No global dependency.
 */

import Swiper from 'swiper/bundle';

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.block-carousel .swiper' ).forEach( ( el ) => {
		/** @type {object} */
		let config = {};

		try {
			config = JSON.parse( el.dataset.swiperConfig || '{}' );
		} catch ( e ) {
			console.warn( '[Carousel] Invalid swiper config on element:', el, e );
		}


		new Swiper( el, config );
	} );
} );

